module.exports = __webpack_public_path__ + "static/9-b2d2be1b6d37d17ab3530008d2860de4.jpg";